module.exports = __webpack_public_path__ + "img/outfield-picnic-pavilion-06.5d482f45.jpeg";